import { i18n as I18n, TOptions } from 'i18next';
import { useTranslation } from 'react-i18next';

interface TranslationResult {
    t: (key: string, options?: TOptions) => string;
    ready: boolean;
    i18n: I18n;
}

const keySuffix = '.text';

const translationKey = (keyPrefix: string): string => `${keyPrefix}${keySuffix}`;

export const useUserProfileTranslation = (): TranslationResult => {
    const i18nUseTranslation = useTranslation();

    return {
        t: (key: string, options?: TOptions) => i18nUseTranslation.t(translationKey(key), options),
        ready: i18nUseTranslation.ready,
        i18n: i18nUseTranslation.i18n,
    };
};
